import { css, modifier, styled } from '@lokalise/styled';

import { color, spacing, typography, value } from '@app/theme';

export const DropzoneContainer = styled.section<{
    $additional?: boolean;
    $isDragAccept: boolean;
    $isDragReject: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${spacing(5)};
    border-radius: ${value('radius.l')};
    background-color: ${color('background.surface.middle')};
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23CFCFCFFF' stroke-width='1' stroke-dasharray='20%2c 10' stroke-dashoffset='75' stroke-linecap='round'/%3e%3c/svg%3e");
    transition: background-image ease-in-out ${value('transition.default')},
        background-color ease-in-out ${value('transition.default')}, color ease-in-out ${value('transition.default')};
    cursor: pointer;
    height: 240px;
    width: 100%;
    border-color: ${color('background.action.danger.default')};

    ${modifier(
        '$additional',
        css`
            height: unset;
        `,
    )};
    ${modifier(
        '$isDragAccept',
        css`
            color: ${color('text.active')};
            background-color: ${color('background.action.secondary.hover')};
            background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%235489DCFF' stroke-width='1' stroke-dasharray='20%2c 10' stroke-dashoffset='75' stroke-linecap='round'/%3e%3c/svg%3e");
        `,
    )};
    ${modifier(
        '$isDragReject',
        css`
            color: ${color('text.danger')};
            background-color: ${color('background.danger')};
            background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23DA3849FF' stroke-width='1' stroke-dasharray='20%2c 10' stroke-dashoffset='75' stroke-linecap='round'/%3e%3c/svg%3e");
        `,
    )}
`;

export const DropzoneTitle = styled.p`
    ${typography('body.base.strong')};
    color: ${color('text.light.default')};
`;

export const DropzoneColoredText = styled.span`
    color: ${color('text.link.default')};
`;

export const DropzoneSubtitle = styled.p`
    ${typography('body.caption.default')};
    color: ${color('text.light.default')};
`;
